import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from '@piconetworks/router-adapter'

import CardEditor from 'apps/containers/Prompt/CardEditor'
import Loader from 'common/modules/loader'
import PaymentV2 from 'common/modules/paymentv2'

import xFrame from 'common/xFrame'

const CardsPage = () => {
    const paymentMethodsData = useSelector(PaymentV2.selectors.getPaymentMethods)
    const defaultPaymentMethod = useSelector(PaymentV2.selectors.getDefaultPaymentMethod)

    const dispatch = useDispatch()

    const linkColor = useSelector(Loader.selectors.linkColor)
    const publisherName = useSelector(Loader.selectors.publisherName)
    const publisherId = useSelector(Loader.selectors.publisherId)

    const onUpdateSuccess = () => xFrame.prompt.showMenuRoute({
        dispatch,
        menuRoute: '/notification',
        text: 'Your payment method has been sucessfully updated.',
    })

    return (
        <CardEditor
            dispatch={dispatch}
            linkColor={linkColor}
            publisherName={publisherName}
            publisherId={publisherId}
            paymentMethodsData={paymentMethodsData}
            defaultPaymentMethod={defaultPaymentMethod}
            onUpdateSuccess={onUpdateSuccess}
            deleteCard={(idToDelete) => {
                const paymentMethodToDelete = paymentMethodsData.find(({ id }) => id === idToDelete)
                if (paymentMethodToDelete) {
                    dispatch(PaymentV2.creators.deletePayment({
                        payload: {
                            publisherId,
                            payload: {
                                source_id: paymentMethodToDelete.id,
                                account: paymentMethodToDelete.account,
                            },
                        },
                    }))
                }
            }}
        />
    )
}

export default withRouter(CardsPage)
